/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dailyStatsGetApiV3DailyStats } from "../../funcs/dailyStatsGetApiV3DailyStats.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3DailyStatsRequest$inboundSchema.optional(),
};

export const tool$dailyStatsGetApiV3DailyStats: ToolDefinition<typeof args> = {
  name: "daily-stats-get-api-v3-daily-stats",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await dailyStatsGetApiV3DailyStats(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
